import { render, staticRenderFns } from "./AddCourseTypeDialog.vue?vue&type=template&id=64bff7b4&scoped=true&"
import script from "./AddCourseTypeDialog.vue?vue&type=script&lang=js&"
export * from "./AddCourseTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bff7b4",
  null
  
)

export default component.exports